/* eslint-disable @typescript-eslint/no-explicit-any */
import { darkTheme as iDarkTheme, theme as iLightTheme } from '@intelie/ui'
import React, { useContext, createContext } from 'react'
import { ThemeProvider, useTheme } from 'styled-components'

import { DashboardContext } from 'live/context/dashboard'
import liveTheme from 'live/services/theme'

import { ResourceGroupConfiguration } from '.'
import { ILivePageProps, IQueryParamsList, IResourceManagerRouteContext } from '../types'
import { defaultParams } from '../utils/constants'

const lightTheme = { ...iLightTheme, ...liveTheme }
const darkTheme = { ...iDarkTheme, ...liveTheme }

function toQueryString(obj: IQueryParamsList): string {
    return Object.keys(obj)
        .filter(key => typeof obj[key] === 'string' || typeof obj[key] === 'number' || typeof obj[key] === 'boolean')
        .map(key => (obj[key] !== undefined && obj[key] !== null ? `${key}=${obj[key]}` : undefined))
        .filter(e => e)
        .join('&')
}

export function setParams(params: IQueryParamsList): void {
    window.location.href = `/#/config/resource_manager_group?${toQueryString(params)}`
}

export const ResourceTypeConfigurationRouteContext = createContext({
    params: defaultParams,
    setParams
} as IResourceManagerRouteContext<any>)

export const ResourceGroupConfigurationWrapper: React.FC<ILivePageProps> = ({ id: params }) => {
    const theme = useTheme()
    const dashTheme = useContext(DashboardContext).theme

    if (theme?.['gray-100']) {
        return (
            <ResourceTypeConfigurationRouteContext.Provider value={{ params: params ?? defaultParams, setParams }}>
                <ResourceGroupConfiguration />
            </ResourceTypeConfigurationRouteContext.Provider>
        )
    } else {
        return (
            <ThemeProvider theme={dashTheme === 'light' ? lightTheme : darkTheme}>
                <ResourceTypeConfigurationRouteContext.Provider value={{ params: params ?? defaultParams, setParams }}>
                    <ResourceGroupConfiguration />
                </ResourceTypeConfigurationRouteContext.Provider>
            </ThemeProvider>
        )
    }
}
